import { render, staticRenderFns } from "./VASlideItem.vue?vue&type=template&id=077ba3f8&scoped=true&"
import script from "./VASlideItem.vue?vue&type=script&lang=js&"
export * from "./VASlideItem.vue?vue&type=script&lang=js&"
import style0 from "./VASlideItem.vue?vue&type=style&index=0&id=077ba3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ba3f8",
  null
  
)

export default component.exports